import type { FC } from "react"
import { useEffect } from "react"
import { useMapGLContext } from "@wayz/react-gl"
import { getPosition } from "@/api"
import { useCreation } from "ahooks-v2"
import { useParams } from "react-router-dom"
import { useControllerModel } from "@/models"
import type { RouterIdsVO } from "@/api"
import { showZoomMap } from "@/constants/constant"
import { getCenterOffset } from "@/util/commonUtils"
// ==============================================
const CityLocation: FC<any> = () => {
  const { cityId } = useParams<RouterIdsVO>() as any
  const { setViewState, getViewState } = useMapGLContext()
  const { isAllShow } = useControllerModel()

  // 城市定位偏移量
  const lngOffset = useCreation(() => {
    const {
      subtract: [offset],
    } = getCenterOffset(getViewState, showZoomMap.DISTRICT)
    return isAllShow ? offset : 0
  }, [isAllShow, getViewState])

  // 是否是右上角城市下拉引起的定位（Header组件内无法定位）
  useEffect(() => {
    // 根据code获取全国或省市区的经纬度
    getPosition(cityId).then((position) => {
      const { longitude, latitude } = position ?? {}
      // 定位
      if (longitude && latitude) {
        setViewState({
          longitude: longitude + lngOffset,
          latitude,
          zoom: showZoomMap.DISTRICT,
        })
      }
    })
  }, [cityId, lngOffset, setViewState])

  return null
}

export default CityLocation
